import { render, staticRenderFns } from "./cleaningprices.vue?vue&type=template&id=78f68750&"
import script from "./cleaningprices.vue?vue&type=script&lang=js&"
export * from "./cleaningprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f68750')) {
      api.createRecord('78f68750', component.options)
    } else {
      api.reload('78f68750', component.options)
    }
    module.hot.accept("./cleaningprices.vue?vue&type=template&id=78f68750&", function () {
      api.rerender('78f68750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rFQS060MIbJh/JS/cleaningprices.vue"
export default component.exports